var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ArrowLeft-Inactive","transform":"translate(1.803 1.868)"},[React.createElement("g",{"id":"Group_47","data-name":"Group 47","opacity":"1","key":0},React.createElement("g",{"id":"Group_21","data-name":"Group 21"},React.createElement("path",{"id":"Path_33","data-name":"Path 33","d":"M11.5,0,1,7l10.5,7Z","transform":"translate(-1)","fill":"rgba(0,0,0,0)","stroke":"#2fb7db","strokeWidth":"2","fillRule":"evenodd"}))),React.createElement("path",{"id":"Path_115","data-name":"Path 115","d":"M334.835,3731h21.8","transform":"translate(-323.366 -3724)","fill":"none","stroke":"#2fb7db","strokeWidth":"2","opacity":"1","key":1})]));
}

LeftArrow.defaultProps = {"width":"35.069","height":"17.737","viewBox":"0 0 35.069 17.737"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
